import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Common components (not lazy-loaded)
import Header from "../Common/header/Header";
import Footer from "../Common/footer/Footer";
import Preloader from "../preloader/preloader";

// Lazy-loaded page components
const Home = lazy(() => import("../home/Home"));
const About = lazy(() => import("../about/About"));

const Rent = lazy(() => import("../rent/Rent"));
const Rent_Bungalow = lazy(() => import("../rent/Rent_Bungalow"));
const Rent_Flat = lazy(() => import("../rent/Rent_Flat"));
const Rent_House = lazy(() => import("../rent/Rent_House"));

const Search = lazy(() => import("../search/Search"));
const SearchDetail = lazy(() => import("../search/SearchDetail"));

const Sale = lazy(() => import("../sale/Sale"));
const Sale_Bungalow = lazy(() => import("../sale/Sale_Bungalow"));
const Sale_Flat = lazy(() => import("../sale/Sale_Flat"));
const Sale_House = lazy(() => import("../sale/Sale_House"));
const Sale_Land = lazy(() => import("../sale/Sale_Land"));
const Sale_Desc = lazy(() => import("../sale/Sale_Desc"));

const Ads = lazy(() => import("../advertisment/Ads"));

const Blog = lazy(() => import("../blog/Blog"));
const Blog_detail = lazy(() => import("../blog/Blog_detail"));
const Properties_detail = lazy(() => import("../properties-detail/Properties_detail"));
const Contact = lazy(() => import("../contact/Contact"));

const Pages = () => {
  return (
    <Router>
      <Header />
      <Suspense fallback={<Preloader />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />

          <Route path="/search" element={<Search />} />
          <Route path="/search-detail" element={<SearchDetail />} />

          <Route path="/rent" element={<Rent />} />
          <Route path="/rent_bungalow" element={<Rent_Bungalow />} />
          <Route path="/rent_flat" element={<Rent_Flat />} />
          <Route path="/rent_house" element={<Rent_House />} />

          <Route path="/ads" element={<Ads />} />

          <Route path="/sale" element={<Sale />} />
          <Route path="/sale_bungalow" element={<Sale_Bungalow />} />
          <Route path="/sale_flat" element={<Sale_Flat />} />
          <Route path="/sale_house" element={<Sale_House />} />
          <Route path="/sale_land" element={<Sale_Land />} />
          <Route path="/sale_desc" element={<Sale_Desc />} />

          <Route path="/blog" element={<Blog />} />
          <Route path="/blog_detail" element={<Blog_detail />} />
          <Route path="/properties_detail" element={<Properties_detail />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </Suspense>
      <Footer />
    </Router>
  );
};

export default Pages;